import {ChangeDetectorRef, Component, OnInit, ViewEncapsulation} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {HasPendingChangesService} from './has-pending-changes.service';

@UntilDestroy()
@Component({
  selector: 'dcp-disable-loading-form',
  templateUrl: './disable-loading-form.component.html',
  styleUrls: ['./disable-loading-form.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class DisableLoadingFormComponent implements OnInit {
  disableForm: boolean = false;

  constructor(
    private hasPendingChangesService: HasPendingChangesService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.hasPendingChangesService
      .hasPendingChanges()
      .pipe(untilDestroyed(this))
      .subscribe((hasPendingChanges) => {
        this.disableForm = hasPendingChanges;
        this.changeDetectorRef.detectChanges();
      });
  }
}
